/* eslint-disable */
import { DateTime } from 'luxon';

/* Get the current instant */
const now = DateTime.now();

export const dvbar = {
   
    fileDistribution  : {
        overview: {
            'current': {
                'new'      : 594,
                'completed': 287,
            },
            'other': {
                'new'      : 594,
                'completed': 287,
            },
        },
        labels  : ['DOC', 'XLS', 'Image', 'PDF', 'Other'],
        series  : {
            'current': [3, 1, 1, 12, 5],
            'other': [3, 1, 1, 12, 5],
        },
    },

    trashUsage : {
        overview: {
            'current': {
                'total' : 198.1,
                'count': 12,
            },
        },
        labels  : ['DOC', 'XLS', 'Image', 'PDF', 'Other'],
        series  : {
            'current': [3, 1, 1, 12, 5],
        },
    },
   
};
